import { Injectable,Inject } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { WINDOW } from '../window.providers';
import * as io from 'socket.io-client';

@Injectable()
export class SocketService {
  private url;
  private hostNameUrl:string;
	private socket;  
  private protocol;
  	constructor(@Inject(WINDOW) private window: Window) { 
      console.log(this.getHostname() + " from soket server")
      this.hostNameUrl =this.getHostname();

      if(this.hostNameUrl=="localhost"){
          this.protocol = this.getprotocall();
          this.url ='http://localhost:3500/web'; 
          //this.url='https://airport.wisefly.in/io'
      }else{
        this.protocol = this.getprotocall()
        //this.url = 'https://'+this.hostNameUrl+'/web';
        this.url = this.protocol+'//'+this.hostNameUrl+'/web';
      }

		  this.socket = io(this.url);
    	this.socket.on('connect',(socket)=>{
    	  console.log("socket connected...! with " + this.url);
    	}) 

  	}

    getprotocall(){
      console.log(this.window.location.protocol);
      return this.window.location.protocol;
    }

    getHostname() : string {
        return this.window.location.hostname;
    }

    geturl(){
      if(this.getHostname() == "localhost")
          return 'http://localhost:3500/'; 
      else
        return (this.getprotocall()+'//'+this.getHostname()+"/");
      
    }

  	sendMessage(obj){//this orgId when perticuler organizational admin login
  		console.log("connection with socket send message " );
    	this.socket.emit('userlocation', obj);    
  	}
    sendAlertMessage(obj){//this orgId when perticuler organizational admin login
      console.log("connection with socket send  Alert message " );
      this.socket.emit('userinrangecovid', obj);    
    }
  	leavePreRoom(obj){
  		console.log("first leave previous Room here");
  		this.socket.emit("leaveroom",obj)
  	} 
  	 getMessages() {
	    let observable = new Observable(observer => {
	     this.socket.on('updateWebClient', (data) => { // here we have to replace as per org login  orgId has to be change
	        observer.next(data);    
	      });
	      return () => {
	        this.socket.disconnect();
	      };  
	    })  
	    return observable;
  	}
    //
    getAlertMessage(){
         let observable = new Observable(observer => {
       this.socket.on('Voilatorswebclient', (data) => { // here we have to replace as per org login  orgId has to be change
          console.log("noti alert");
          observer.next(data);    
        });
        return () => {
          this.socket.disconnect();
        };  
      })  
      return observable;
    } 
}
 


// WEBPACK FOOTER //
// ./src/app/services/socket/socket.service.ts